<template>
  <div class="details-container">
    <div class="details-wrapper">
      <h1 class="title">Product Details<span>Sublimation</span></h1>
      <p class="content">
        T-Shirts, Hoodies, Golf Shirts, Tracksuits, Boardwalk Shorts, Vests,
        Rugby Shirts, Cricket Shirts, Hockey Shirts, Netball, Baseball, Cycling,
        Activewear / Leggings, Shorts - 3/4 OR Full Length, Crop Tops, Tank
        Tops, Skintight T-Shirts, MMA Tight or Loose Shorts, Sweater, Soccer
        Shirts and Short Pants, Rugby, Soccer and Netball Bib, Athletic Vests,
        Basketball Vest and Shorts, Matric Tops. All items can be short or long
        sleeve. Collars can vary between Round Neck, V-Neck , Placket, V-Neck
        Crossover, ETC..
      </p>
    </div>
    <div class="title"></div>
  </div>
</template>


<style scoped>
.details-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  position: relative;
  max-width: 1300px;
  overflow: auto;
  margin: 1rem auto;
}
.details-wrapper {
  text-align: left;
  max-width: 80ch;
  line-height: 1.5;
}
.title {
  font-family: boombox, Helvetica, Arial, sans-serif;
  text-transform: uppercase;
  text-align: center;
  font-size: 1.75rem;
  margin-bottom: 0.5rem;
}

.title span {
  line-height: 2.5rem;
  display: block;
  font-size: 1.2rem;
  color: rgb(77, 88, 238);
  margin-bottom: 0.5rem;
}
.content {
  font-weight: 600;
  font-size: 1.1rem;
}

/* ----------------------------- Media------------------******************/
@media screen and (min-width: 500px) {
  .details-container {
    height: 400px;
  }
  .title {
    font-size: 2.25rem;
  }
}
@media screen and (min-width: 768px) {
}
</style>